<template>
  <div class="heatnumber">
    <div class="framework">
      <div class="total-heat">
        <el-container>
          <el-aside width="214px">
            <el-row class="tac">
              <el-menu
                :default-active="indexs || activeMenu"
                class="el-menu-vertical-demo"
                @open="handleOpe"
                @close="handleClos"
                router
                style="border: 1px solid #f0f0f0"
              >
                <el-menu-item class="bar" index="/ropularity">
                  <i class="iconfont gos-huo"></i>
                  <span> 人气排行 </span>
                </el-menu-item>
                <el-menu-item class="bar" index="/collection">
                  <i class="iconfont gos-mn_shoucang_fill"></i>
                  <span> 收藏排行 </span>
                </el-menu-item>
                <el-menu-item class="bar" index="/Scoresranking">
                  <i class="iconfont gos-B-pingfen"></i>
                  <span> 评分排行 </span>
                </el-menu-item>
                <el-menu-item class="bar" index="/latestupload">
                  <i class="iconfont gos-shangchuan"></i>
                  <span> 最新上传 </span>
                </el-menu-item>
              </el-menu>
            </el-row>
          </el-aside>
          <el-main><router-view /></el-main>
        </el-container>
      </div>
    </div>
  </div>
</template>
<script>
import Bus from "@/utils/bus";
export default {
  data() {
    return {
      indexs: "",
    };
  },
  mounted() {
    // Bus.$emit('activeRouter', '/heatnumber')
  },
  methods: {
    handleOpe(key, keyPath) {},
    handleClos(key, keyPath) {},
  },
  computed: {
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
  },
};
</script>
<style scoped lang="scss">
.framework {
  width: 100%;
  margin: 0 auto;
  background: #fff;
}
.heatnumber {
  width: 100%;
  margin-top: 10px;
  background: #fff;
  // background: red;
  .total-heat {
    padding: 24px 22px 0px 18px;
    width: 1001px;
    margin: 0 auto;
    background: #fff;
    margin-bottom: 10px;
  }
}
.bar {
  width: 211px;
  height: 52px;
  background: #ffffff;
  border-radius: 4px;
  line-height: 52px;
  border-left: 4px solid #fff;
  i {
    line-height: 52px;
  }
}
.el-aside {
  margin-right: 10px;
  color: #333;
  background: #fff;
  // color: #333;
}
.el-main {
  padding: 0;
}
.el-menu-vertical-demo {
  .el-menu-item.is-active {
    color: rgb(76, 202, 255);
    border-left: 4px solid rgb(76, 202, 255);
    background: #f9f9f9;
    line-height: 52px;
  }
}
</style>
